import { PricingModules, usePricingModulesState } from '../../context/contexts/PricingModuleContext';
import { isUserPermitted } from '../../TowerMenu/TowerMenuUtils';
import { TOWER_MENU_ITEMS, ROLES } from '@silverfort-nodelibs/common/utils/consts';
import { Icons } from '@silverfort/sf-components';
import { LogicalItemsTypes } from '../../TowerMenu/logicalMenuItems/LogicalItemsTypes';
import { MenuItemContainer } from '../../TowerMenu/logicalMenuItems/MenuItemContainer';

const ITDR_MAIN_TITLE = 'ITDR';
const ICON = Icons.Target;

export const ITDRLogicalMenuItems = ({
    handleMenuItemSelection,
    userData,
    getTowerMenuHref,
    ...props
}: LogicalItemsTypes) => {
    const { pricingModulesState } = usePricingModulesState();

    const hasCloudLicense = pricingModulesState?.[PricingModules.ITDR]?.cloudEnabled;
    const hasOnPremLicense = pricingModulesState?.[PricingModules.ITDR]?.onPremEnabled;

    const hasOnPremPermission = isUserPermitted(userData, 'risk', ROLES.VIEWER.value);
    const hasCloudPermission = isUserPermitted(userData, 'cloudRisk', ROLES.VIEWER.value);

    const isITDREnabled = hasOnPremLicense || hasCloudLicense;

    return (
        <MenuItemContainer
            {...props}
            parentId={TOWER_MENU_ITEMS.ITDR}
            mainTitle={ITDR_MAIN_TITLE}
            icon={ICON}
            userData={userData}
            showOnlyFirstItem={!isITDREnabled}
            handleMenuItemSelection={handleMenuItemSelection}
            getTowerMenuHref={getTowerMenuHref}
            menuItems={[
                {
                    id: TOWER_MENU_ITEMS.ITDR_AD,
                    title: 'Active Directory',
                    disabled: !hasOnPremPermission
                },
                {
                    id: TOWER_MENU_ITEMS.ITDR_CLOUD,
                    title: 'Cloud',
                    disabled: hasCloudLicense && !hasCloudPermission
                }
            ]}
        />
    );
};
